import React from 'react'
import { makeStyles } from '@material-ui/core'
import { purple } from '@material-ui/core/colors'
import { FONT_WEIGHTS } from '../../../utils'

const useStyles = makeStyles(() => ({
	root: { display: 'flex', flexDirection: 'row', gap: '0.625rem' },
	spacer: { flex: 1 },
	tabContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		gap: '0.4rem'
	},
	topLine: { fontFamily: 'Nunito', textAlign: 'center', fontWeight: FONT_WEIGHTS.Bold, fontSize: '0.875rem' },
	bottomLine: { fontFamily: 'Nunito', textAlign: 'center', fontSize: '0.875rem' },
	bar: { height: '0.2rem', borderRadius: '0.1rem', backgroundColor: 'transparent', margin: '0 .4rem' },
	activeText: { fontWeight: FONT_WEIGHTS.ExtraBold },
	activeBar: { backgroundColor: purple[500] }
}))

const SectionNavigator = ({ sections = {}, activeSectionId = '' }) => {
	const classes = useStyles()

	return (
		<div className={classes.root}>
			<div className={classes.spacer}></div>
			{Object.entries(sections).map(([id, { sectionName, sectionTitle }], i) => {
				return (
					<div key={`section-${i}`} className={classes.tabContainer}>
						<div className={classes.topLine}>{sectionName}</div>
						<div className={`${classes.topLine} ${id === activeSectionId && classes.activeText}`}>
							{sectionTitle}
						</div>
						<div className={`${classes.bar} ${id === activeSectionId && classes.activeBar}`}></div>
					</div>
				)
			})}
			<div className={classes.spacer}></div>
		</div>
	)
}

export default SectionNavigator
